/* eslint-disable react/prop-types */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Anchor,
  ButtonPrimary,
  ButtonTertiary,
  Heading,
  IconButton,
  IconClose,
  IconTrash,
} from '@americanexpress/dls-react';
import OverflowItem from '../../OverflowItem/OverflowItem';
import { saveSearchListStyle } from '../../../styles/AdvancedFormSearch/AdvStyleList';

const AdvSavedSearch = ({
  pageData,
  setPageData,
  savedSearchList,
  onItemClick,
  showPopup,
  setShowPopup,
  handleFormReset,
  selectedItem,
  setSelectedItem,
}) => {
  const ModalRef = useRef(null);

  const onClose = () => {
    setShowPopup(!showPopup);
  };

  const handleClickOutside = (event) => {
    if (ModalRef.current && !ModalRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    if (!showPopup) return;
    document.addEventListener('mousedown', handleClickOutside, true); // use capture phase
    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [onClose]);

  const onItemActionClickHandler = (action, item) => {
    onItemClick(action, item);
    onClose();
  };

  const onItemSelect = (item) => {
    const newPageData = { ...pageData };
    const itemData = item?.metaDataJson || {};
    pageData.formFields.forEach((field) => {
      // eslint-disable-next-line max-len
      newPageData.formFields[field.id].value = Object.prototype.hasOwnProperty.call(itemData, field.name)
        ? itemData[field.name]
        : '';
    });
    newPageData.formFields.forEach((field) => {
      if (field.type === 'multi-select' || field.type === 'multi-selectV2') {
        const value = newPageData.formFields[field.id].value;
        let selectedIds = [];
        if (value && value.includes(',')) {
          selectedIds = value.split(',').map(v => Number.parseInt(v.trim(), 10));
        } else if (value) {
          selectedIds = [Number.parseInt(value, 10)];
        }
        newPageData.formFields[field.id].selectedIds = selectedIds;
      }
    });
    setPageData(newPageData);
    setShowPopup(false);
  };

  return (
    <div id="saveSearch-action-component" style={{ display: 'inline-block', marginLeft: '25px' }} ref={ModalRef}>
      <OverflowItem
        labelComponent={(
          <ButtonTertiary
            type="button"
            id="AdvFormActionButtons-saveSearch-form"
            className="col-md-1 margin-responsive-r"
            onClick={onClose}
          >
            Saved Searches
          </ButtonTertiary>
        )}
        width="350"
        id="item-action-overflowItem"
        isLabelComponentClicked={showPopup}
        isOutsideClick={false}
      >
        <div
          aria-label="Popup Action List"
          id="item-action-navigation"
          css={saveSearchListStyle['.navigation']}
        >
          <div css={saveSearchListStyle['.header']}>
            <Heading
              id="AdvFormSaveSearch-formHeader"
              level={1}
              className="dls-gray-06"
              headingStyle="heading3"
            >
              Saved Searches
            </Heading>
            <IconButton
              style={{ width: '5px', marginLeft: '15px' }}
              id="AdvFormSaveSearch-advSearchClose"
              styleType="tertiary"
              icon={<IconClose size="sm" />}
              onClick={onClose}
            />
          </div>
          <div css={saveSearchListStyle['.listBlock']}>
            {savedSearchList.map((item) => (
              <div
                key={item.id}
                css={{
                  ...saveSearchListStyle['.listBlockItem'],
                  backgroundColor: selectedItem?.id === item.id ? '#ECEDEE' : 'transparent', // Apply grey background if clicked
                }}
              >
                <Anchor
                  theme={{
                    padding: '0px !important',
                    marginLeft: '10px !important',
                    textDecoration: 'none !important',
                    minHeight: 'none !important',
                  }}
                  id={`${item.id}-AdvFormSaveSearch-saveSearchName`}
                  onClick={() => {
                    setSelectedItem({ ...item }); // Ensure a new object reference for React
                    onItemSelect(item);
                  }}
                >
                  {item.searchName}
                </Anchor>
                <ButtonTertiary
                  icon={<IconTrash size="sm" />}
                  size="sm"
                  onClick={() => {
                    handleFormReset();
                    onItemActionClickHandler('DELETE', item);
                  }}
                  theme={{
                    color: '#C85250 !important',
                    fill: '#C85250 !important',
                  }}
                  style={{ width: '5px' }}
                  id={`${item.id}-AdvFormSaveSearch-advSearchDelete`}
                />
              </div>
            ))}{savedSearchList.length === 0 ? ' No saved search available' : ''}
          </div>
          <div>
            <div css={saveSearchListStyle['.navigationItemList']}>
              <ButtonPrimary
                id="AdvFormActionButtons-saveSearch-close"
                onClick={onClose}
                theme={saveSearchListStyle['.saveButtonTheme']}
                style={saveSearchListStyle['.saveButton']}
              >
                Close
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </OverflowItem>
    </div>
  );
};

AdvSavedSearch.displayName = 'AdvSavedSearch';

AdvSavedSearch.propTypes = {
  pageData: PropTypes.shape({
    formHeader: PropTypes.string,
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
  setPageData: PropTypes.func.isRequired,
  savedSearchList: PropTypes.arrayOf(PropTypes.shape({})),
  onItemClick: PropTypes.func.isRequired,
  showPopup: PropTypes.bool.isRequired,
  setShowPopup: PropTypes.func.isRequired,
};

export default AdvSavedSearch;
